import React, { useEffect } from "react";
import { useRoutes, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import "./App.css";
import useAuth from "./hooks/useAuth";
import useScrollReset from "./hooks/useScrollReset";
import useSettings from "./hooks/useSettings";
import SplashScreen from "./components/SplashScreen";
import routes from "./routes";
import { createCustomTheme } from "./theme";
import { connectWithSocketIOServer } from "./utils/wss";
import { createIndexedDB } from "./utils/uploadBlobsToS3";
import { setNavigate } from "./utils/navigatorRef";

const App = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();
  const navigate = useNavigate();
  useScrollReset();

  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme,
  });

  useEffect(() => {
    setNavigate(navigate);
    connectWithSocketIOServer();
    createIndexedDB();
  }, [navigate]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster position="top-center" />
      {auth.isInitialized ? content : <SplashScreen />}
    </ThemeProvider>
  );
};

export default App;
